import resourceConfig from '../config';

export default {
  resources: {
    [resourceConfig.name]: {
      enums: {
        RETAIL_RETURN: 'Возврат продажи',
        REMOTE_SALE_RETURN: 'Удаленный возврат',
        RECEIPT_RETURN: 'Возврат чека',
      },
    }
  }
}
